module.exports = {
      id: "fb-dark-greybg-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#fb-dark-greybg",
      toString: function () {
        return this.url;
      }
    }